import { http, ep } from '../../client/http';

export const historyRepo = {
  get: async () => {
    const res = await http.get(ep('history/list?limit=1000'), {
      params: { status: true }
    });
    return res.data.data;
  }
};
